$shm_hitalama_draglist_item $rise_drag_absolute
	transition_smooth \top 0.2s, left 0.2s, right 0.2s, bottom 0.2s, width 0.2s, height 0.2s
	style *
		^
		transition <= transition \none
	hovered? false
	plugins /
		^
		<= Hovered $shm_hitalama_hovered
			hovered? <=> hovered? false
	event *
		click? <=> click? null
